import React from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';

import { JudgeMyDressageCustomTheme } from '../../styles/config';

const useStyles = makeStyles((_theme: JudgeMyDressageCustomTheme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: '400px',
  },
}));

type LoadingProps = {};

const Loading: React.FC<LoadingProps> = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <CircularProgress />
    </div>
  );
};

export default Loading;
